// extracted by mini-css-extract-plugin
export var aura = "fourAdvantagesPoints-module--aura--coEwL";
export var bezProcentov = "fourAdvantagesPoints-module--bezProcentov--RQDLg";
export var blackFridayHalva = "fourAdvantagesPoints-module--blackFridayHalva--N3HHL";
export var container = "fourAdvantagesPoints-module--container--dPUhU";
export var creditCardMedia = "fourAdvantagesPoints-module--creditCardMedia--nR4bo";
export var creditCardMedia180Dnej = "fourAdvantagesPoints-module--creditCardMedia180Dnej--jn0Rw";
export var dashed = "fourAdvantagesPoints-module--dashed--U+dqN";
export var genderActionMedia = "fourAdvantagesPoints-module--genderActionMedia--owGTS";
export var halvaDlyaGamerov = "fourAdvantagesPoints-module--halvaDlyaGamerov--LE8qL";
export var halvaMedia = "fourAdvantagesPoints-module--halvaMedia--vP5I4";
export var headTitle = "fourAdvantagesPoints-module--headTitle--A-ERI";
export var img = "fourAdvantagesPoints-module--img--TL-hC";
export var inviteFriend = "fourAdvantagesPoints-module--inviteFriend--Lwigc";
export var land = "fourAdvantagesPoints-module--land--ZwbvO";
export var left = "fourAdvantagesPoints-module--left--v0GsW";
export var mediaD = "fourAdvantagesPoints-module--mediaD--TLv1L";
export var nedeliUmnyhRassrochek = "fourAdvantagesPoints-module--nedeliUmnyhRassrochek--bXvSc";
export var newStickers = "fourAdvantagesPoints-module--newStickers--a28dh";
export var newYear = "fourAdvantagesPoints-module--newYear--51GHp";
export var newYearMedia = "fourAdvantagesPoints-module--newYearMedia---1No1";
export var pkwBonus1500 = "fourAdvantagesPoints-module--pkwBonus1500--0VGZY";
export var pkwCreditCard = "fourAdvantagesPoints-module--pkwCreditCard--R0Wpp";
export var pkwCreditCards = "fourAdvantagesPoints-module--pkwCreditCards--4ScJ1";
export var pkwRedesign = "fourAdvantagesPoints-module--pkwRedesign--9OpaP";
export var plait = "fourAdvantagesPoints-module--plait--p8LWu";
export var planetaCard = "fourAdvantagesPoints-module--planetaCard--36j7A";
export var rassrochkaNaAuto = "fourAdvantagesPoints-module--rassrochkaNaAuto--rbdDd";
export var redisignBezProcentov = "fourAdvantagesPoints-module--redisignBezProcentov--flgf9";
export var refinZadolzhennostej = "fourAdvantagesPoints-module--refinZadolzhennostej--0ExXD";
export var section = "fourAdvantagesPoints-module--section--6e2q+";
export var special = "fourAdvantagesPoints-module--special--vbuqx";
export var subtitle = "fourAdvantagesPoints-module--subtitle--hUJEQ";
export var text = "fourAdvantagesPoints-module--text--C+9ID";
export var thirdAdvantagesPoints = "fourAdvantagesPoints-module--thirdAdvantagesPoints--6EXB1";
export var title = "fourAdvantagesPoints-module--title--8QXcr";
export var wrap = "fourAdvantagesPoints-module--wrap---TxJ-";
export var wrapper = "fourAdvantagesPoints-module--wrapper--qGl-w";
export var zhkh = "fourAdvantagesPoints-module--zhkh--ONR1M";